import {
    Component,
    ElementRef,
    EventEmitter,
    Input, OnChanges,
    Output, SimpleChanges,
    ViewChild
} from '@angular/core';

@Component({
    selector: 'app-floating-label-input',
    templateUrl: './floating-label-input.component.html',
    styleUrls: ['./floating-label-input.component.scss']
})
export class FloatingLabelInputComponent implements OnChanges {

    @Input() id!: string;
    @Input() type: string = 'text';
    @Input() placeholder: string = '';
    @Input() model!: any;
    @Input() setErrorState: boolean = false;
    @Input() errorMessage: string = '';

    @Output() modelChange: EventEmitter<any> = new EventEmitter<any>();

    @ViewChild('inputElement') inputElement!: ElementRef;
    @ViewChild('inputLabelElement') inputLabelElement!: ElementRef

    constructor() {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['setErrorState'] && !changes['setErrorState'].firstChange) {
            this.setInputFieldErrorState(this.id, this.setErrorState);
        }
    }

    setInputFieldErrorState(id: string, showErrorState: boolean) {
        const inputEl = this.inputElement.nativeElement;
        const labelEl = this.inputLabelElement.nativeElement;

        if (inputEl.id === id) {
            if (showErrorState) {
                this.setInputErrorState(inputEl, labelEl);
            } else {
                this.removeInputErrorState(inputEl, labelEl);
            }
        }
    }

    setInputErrorState(inputEl: HTMLElement, labelEl: HTMLElement) {
        inputEl.focus();
        inputEl.classList.add('input-error');
        labelEl.classList.add('label-error');
    }

    removeInputErrorState(inputEl: HTMLElement, labelEl: HTMLElement) {
        inputEl.classList.remove('input-error');
        labelEl.classList.remove('label-error');
    }


    focusInput() {
        if (this.inputElement) {
            this.inputElement.nativeElement.focus();
        }
    }

    onInputChange(event: any) {
        this.modelChange.emit(event.target.value);
    }

}
